module.exports = __webpack_public_path__ + "static/media/庆新织点.fe59f1fe.jpg";